import React, { useContext, useEffect, useState } from 'react';
import CountryTabItem from '../../../../wdi-ranking/components/countryTabs/components/rankingTabPanel';
import CustomTabs from '../../../../ui/customTabs';
import * as styles from './styles.module.scss';
import { MicrocopyContext } from '../../../../../context/microcopy.context';
import { getCopy } from '../../../../../helpers/copy';

import { getAPIRoot } from '../../../../../helpers/fetch';
import { API_ROUTES } from '../../../../../utils/constants';

const ContinentRankings = ({}) => {
  const microcopy = useContext(MicrocopyContext);

  const [ranking, setRanking] = useState([]);

  const fetchRankings = async () => {
    let apiRoot = await getAPIRoot();

    await fetch(`${apiRoot}${API_ROUTES.TOP_BYCONTINENT}`)
      .then((res) => res.json())
      .then((res) => {
        setRanking(res.continents);
      });
  };

  const renderContinentTab = (continent) => (
    <CountryTabItem
      headline={`${getCopy(
        'label.wdiOverviewPanelHeadline',
        microcopy
      )} ${getRegionLabel(continent.name)}`}
      items={continent.items.sort((a, b) => a.position - b.position) || []}
    />
  );

  const getRegionLabel = (region) =>
    getCopy(
      `filters.region.${region.replace(' ', '').toLowerCase()}`,
      microcopy
    ).toUpperCase();

  useEffect(() => {
    fetchRankings();
  }, []);

  return (
    <div>
      <CustomTabs
        tabList={ranking.map((continent) => getRegionLabel(continent.name))}
        tabPanels={ranking.map(renderContinentTab)}
        forceRenderTabPanel
      />
    </div>
  );
};

export default ContinentRankings;
